<template>
  <v-container>
    <v-row>
      <v-col>
        <v-data-table
          :show-select="true"
          v-model="computedAssigned"
          :headers="headers"
          :items="computedSearchedItems"
          :hide-default-footer="true"
          :disable-pagination="true"
          @click:row="handleClick"
        >
          <template #item.filename="{ item }">
            <v-icon :color="item.iconColor"> {{ item.icon }} </v-icon>
            {{ item.filename }}
          </template>
          <template #item.added_by="{ item }">
            {{ users[item.added_by].name }}
          </template>
          <template #item.added_at="{ item }">
            {{ item.date }}
          </template>
          <template #item.size="{ item }"> {{ item.byte }} </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get } from 'vuex-pathify';
import { getIconColorByFileType, getIconByFileType } from '@/assets/js/utility';

export default {
  name: 'AttachmentListView',
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    assigned: {
      type: Array,
      required: false,
    },
  },
  data: vm => ({
    headers: [
      { text: vm.$i18n.t('dialog.attachments.headers.name'), value: 'filename' },
      { text: vm.$i18n.t('dialog.attachments.headers.owner_name'), value: 'added_by' },
      { text: vm.$i18n.t('dialog.attachments.headers.added_at'), value: 'added_at' },
      { text: vm.$i18n.t('dialog.attachments.headers.size'), value: 'size' },
    ],
  }),
  computed: {
    users: get('users/users'),
    computedAssigned: {
      get() {
        return this.assigned;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    computedSearchedItems() {
      return this.attachments.map(item => {
        return {
          ...item,
          icon: getIconByFileType(item.filename),
          iconColor: getIconColorByFileType(item.filename),
          date: this.$dayjs(item.added_at).format('L'),
          byte: this.formatBytes(item.size),
        };
      });
    },
  },
  methods: {
    formatBytes(bytes, decimals = 0) {
      if (bytes === 0) {
        return '0 B';
      }
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
    },
    handleClick(a) {
      if (this.computedAssigned.includes(a)) {
        this.computedAssigned = this.computedAssigned.filter(at => at !== a);
      } else {
        this.computedAssigned.push(a);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-simple-checkbox .v-icon {
  color: #1a73e8 !important;
}
</style>
